import { render } from "./Home.vue?vue&type=template&id=08e237aa&scoped=true&bindings={}"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=08e237aa&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-08e237aa"

export default script